import http from "@/http/aisea/axios";
import qs from "qs";

const resource = "/enterprises/manning/vessels/crews/todos";

export default {
  fetch(payload = {}) {
    return http.get(resource, {
      params: payload,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },

  fetchTodoValue(crewId, todoId) {
    return http.get(
      `/enterprises/manning/vessels/crews/${crewId}/todos/${todoId}/values`,
      {
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );
  },

  updateTodoValue(crewId, todoId, data) {
    return http.put(
      `/enterprises/manning/vessels/crews/${crewId}/todos/${todoId}/values`,
      data
    );
  },
};
